import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import CarAttributes from './components/CarAttributes';

import { TListingClient } from 'types/TListing';

type TCarAttributesAppProps = {
  appState: {
    listing: TListingClient;
  };
  environment: any;
};

const CarAttributesApp = ({ appState, environment }: TCarAttributesAppProps) => {
  const {
    listing: { itemId, carDetails, carAttributes, flags },
  } = appState;
  const { hasDealerHighlights } = flags;

  return (
    <EnvironmentProvider value={environment}>
      <CarAttributes
        carDetails={carDetails}
        carAttributes={carAttributes}
        itemId={itemId}
        hasDealerHighlights={hasDealerHighlights}
      />
    </EnvironmentProvider>
  );
};

export default CarAttributesApp;
